<div class="hero-banner udex-py-24 udex-py-md-32 udex-py-lg-40">
  <div class="udex-grid udex-mx-auto">
    <udex-search
      class="d-block udex-mx-auto udex-my-8 col-12 col-md-8 col-lg-6"
      id="search"
      value
      language-voice="en-US"
      mode="Home Search"
      label="{{type}}"
      [attr.suggestion-list]="suggestionListString"
      show-submit-button
      (handle-value-search)="handleSearch($event?.detail?.value)"
      (submit-search-value)="submitSearch($event?.detail?.value)"
      (handle-value-reset)="clearSearch()"
      [attr.accessible-name-search-icon]="'search.search' | cxTranslate"
      [attr.accessible-name]="'search.search' | cxTranslate"
      [attr.tooltip-submit-button]="'search.search' | cxTranslate"
      role="Search">
    </udex-search>
  </div>
</div>
